<!--
 * @Description:
 * @Author: cooky
 * @Date: 2021-03-01 17:30:43
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-12 15:05:04
-->
<template>
  <div>
    <div class="form-item server">
      <SSelect v-model="server" class="select" :placeholder="$t('role_nickname')" @change="changeServer">
        <SSelectOption
          v-for="(serverItem, index) in serverRoleList"
          :value="serverItem.server_name"
          :key="index"
        >
          {{ serverItem.server_name }}
        </SSelectOption>
      </SSelect>
    </div>
    <div class="form-item role">
      <SInput
        v-model="nickName"
        class="select"
        disabled
        :placeholder="$t('role_nickname')"
      >
      </SInput>
    </div>
    <div class="tip-red">{{ $t("binding_tip") }}</div>
    <s-button size="large" :loading="loading" @click="handleSelectServer">{{ $t('ok') }}</s-button>
  </div>
</template>
<script>
import { getServerAndRole, setCurrentRole } from '@/api'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ServerRole',
  data () {
    return {
      server: '',
      roleId: '',
      nickName: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters(['serverName', 'serverRoleList', 'roleName'])
  },
  created () {
    this.getServerAndRole()
  },
  // watch: {
  //   lang () { // 改变语言，重新获取区服
  //     this.init()
  //   }
  // },
  methods: {
    ...mapMutations([
      'SET_SERVER_NAME',
      'SET_ROLE_NAME',
      'SET_TOKEN'
    ]),
    async init () {
      await this.getServerAndRole()
      console.log('beforeRouteEnter 选择区服')
      if (this.serverRoleList || this.serverRoleList.length === 0) { // 该语言下无区服，重新绑定角色
        this.$info({
          content: () => {
            return this.$t('please_bind_role_info')
          },
          okText: this.$t('ok')
        })
        this.$store.commit('SET_ROLE_Id', null)
        this.$router.replace({ name: 'RoleBinding' })
      }
    },
    async getServerAndRole () { // 切换角色打开区服，要默认选中之前区服
      if (this.serverRoleList.length > 0) {
        this.setDefaultServer()
        return
      }
      const { code, data } = await getServerAndRole()
      if (code === 0) {
        this.$store.commit('SET_SERVER_ROLE_LIST', data.server_list)
        this.setDefaultServer()
      }
    },
    // 设置默认选择区服，未选择过，则设置第一个区服及角色，否则保持上次选择
    setDefaultServer () {
      this.server = this.serverName || this.serverRoleList[0] && this.serverRoleList[0].server_name
      this.changeServer(this.server)
    },
    changeServer (serverName) {
      const serverItem = this.serverRoleList.find(item => item.server_name === serverName)
      if (serverItem) {
        this.nickName = serverItem.nickname
        this.roleId = serverItem.id
        // this.appId = serverItem.logical_region_id
      }
    },
    // 选择区服完毕，进入购买项选择
    async handleSelectServer () {
      await this.selectRole()
      if (this.$route.path !== '/buying') this.$router.replace({ path: '/buying' })
      this.$emit('select')
    },
    // 设置当前角色
    async selectRole () {
      this.loading = true
      // TODO info提示
      const { code, data } = await setCurrentRole({
        id: this.roleId // 角色编号
      })
      if (code === 0) {
        this.SET_TOKEN(data.token)
        this.SET_SERVER_NAME(this.server)
        this.SET_ROLE_NAME(this.nickName)
      }
      this.loading = false
    }
  }
}
</script>
<style lang="less" scoped>
.select {
    margin-bottom: 24px;
    }
  .tip-red {
    color:#f7314e;
    margin: 35px 0 14px;
    text-align: center;
    font-size: 16px;
  }
@media screen and (max-width: 750px) {
   .select {
       margin-bottom: 4.8rem;
   }
   .tip-red {
       font-size: 2.4rem;
       margin: 4rem 0 1.8667rem;
   }
   .tip-orange {
        margin: 4.5333rem 0 7.4667rem;
   }
}
</style>
